import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
const HTML = document.querySelector("html");
class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == void 0) {
          const figure = $el.closest("figure");
          if (figure)
            figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure)
          figure.classList.add("img-is-loaded");
      },
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      }
    });
    this.selectBg();
    this.inViewport();
  }
  selectBg() {
    const elts = document.querySelectorAll("[data-color]");
    if (elts) {
      let currentBg = null;
      let currentLogo = null;
      elts.forEach((el) => {
        el.addEventListener("mouseenter", () => {
          const targetBg = document.querySelector(`.bg .${el.dataset.color}`);
          if (currentBg != null) {
            gsap.to(currentBg, {
              autoAlpha: 0
            });
          }
          if (targetBg) {
            gsap.to(targetBg, {
              autoAlpha: 1,
              duration: 0.3
            });
            currentBg = targetBg;
          }
        });
        el.addEventListener("mouseleave", () => {
          gsap.to(currentBg, {
            autoAlpha: 0
          });
          currentBg = null;
          currentLogo = null;
        });
      });
    }
  }
  inViewport() {
    inView.offset({
      bottom: window.innerHeight * 0.1
    });
    inView(".js-reveal:not(.is-visible)").on("enter", function(elt) {
      elt.dispatchEvent(new Event("inview"));
      elt.classList.add("is-visible");
      elt.classList.remove("not-visible");
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true" || video && video.dataset.autoplay == "true") {
        const v = video || elt;
        const playPromise = v.play();
        if (playPromise !== null) {
          playPromise.catch(() => {
            v.play();
          });
        }
      }
    }).on("exit", function(elt) {
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" || video && video.dataset.autoplay != "") {
        const v = video || elt;
        v.pause();
      }
      elt.dispatchEvent(new Event("outview"));
      elt.classList.add("not-visible");
    });
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new App();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
